import { db } from "@/firebaseConfig";

const stripeProductsCollection = db.collection("stripe_products");

const saveStripeProduct = async (id, data) => {
  stripeProductsCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("StripeProduct successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateStripeProduct = async (id, data) => {
  stripeProductsCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("StripeProduct successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteStripeProduct = async id => {
  stripeProductsCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("StripeProduct successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getStripeProductById = async id => {
  return stripeProductsCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  stripeProductsCollection,
  saveStripeProduct,
  updateStripeProduct,
  deleteStripeProduct,
  getStripeProductById
};
